var React = require('react');

function EditIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7","key":0}),React.createElement("path",{"d":"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z","key":1})]);
}

EditIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-edit"};

module.exports = EditIcon;

EditIcon.default = EditIcon;
